import { InputHTMLAttributes } from 'react';

type PhoneInputFieldProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  viewOnly: boolean;
  isSubmittedOnce: boolean;
  error?: string;
  isPhone?: boolean;
  isForeignAddress?: boolean;
  country?: string
};
function PhoneInputField(props: PhoneInputFieldProps) {
  const { label, viewOnly, isSubmittedOnce, error, ...rest } = props;

  return (
    <>
      <label className="block mb-2 font-semibold text-gray-600">{label}</label>
      {props.isPhone ? (
        <div className={`w-full flex items-center rounded-md overflow-hidden text-gray-900
            ${
          viewOnly ? 'bg-transparent' : 'bg-transaparent text-gray-900'
        }`}>
          <div className={`px-2 py-2 bg-transparent text-gray-600 text-base font-normal border-t-2 border-l-2 border-b-2 border-[#D7D7D7]${
            viewOnly ? 'bg-gray-600' : 'bg-transparent'
          }`}>
            {"+1"}
          </div>
          <input
            readOnly={viewOnly}
            className={`flex-1 px-2 py-2 text-base font-normal bg-transparent outline-none border-2 border-[#D7D7D7] appearance-none focus:outline-none focus:ring-0 focus:border-[#6491C3] peer ${
              viewOnly ? 'text-grey-200' : 'text-gray-900'
            }`}
            {...rest}
          />
        </div>
      ) : (
        <input
          readOnly={viewOnly}
          className={`w-full text-[#999999] rounded bg-transparent ${
            viewOnly ? 'text-grey-50' : 'border border-grey-500 px-2 py-2'
          }`}
          {...rest}
        />
      )}
      {!viewOnly && (
        <div className="h-[1rem]">
          {error && (
            <span
              className={`text-xs ${
                isSubmittedOnce ? 'text-red-600' : 'text-blue-500 px-4 py-2 flex flex-col sm:flex-row sm:justify-between sm:items-center'
              }`}
            >
              {error}
            </span>
          )}
        </div>
      )}
    </>
  );
}

export default PhoneInputField;